/**
 * Project : workspace
 * File    : CountryPickerView.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package component.country

import androidx.compose.runtime.Composable
import com.parmartechnologies.core.country.CountryCode

@Composable
/**
 * Executes the country picker view operation.
 *
 * @receiver TODO
 * @param onDialCodeChange The on dial code change.
 * @return Unit – no return value.
 */
fun CountryPickerView(onDialCodeChange: (CountryCode) -> Unit) {
    val countryCode = CountryPicker()
    countryCode.CountryCodeDialog(
        pickedCountry = {
            onDialCodeChange(it)
//            Log.v("TAG", "country name is : ${it.countryName}")
        },
        dialogSearch = true,
        dialogRounded = 22
    )
}